import React, { useState } from 'react'
import WorkerCalleDisplay from '../components/workerCalles/WorkerCalleDisplay'
import WorkerCalleForm from '../components/workerCalles/WorkerCalleForm'


export default function WorkerCallsData() {
    const [showForm, setShowForm] = useState(false);
    return (
        <div className="layout-body">
            <div className="col-md-12 worker-call">
                <div className='text-center mmt-3 mb-3'>
                    <button className="btn btn-warning" onClick={() => setShowForm(true)}>
                        Add Worker Call
                    </button>
                </div>
                <WorkerCalleForm isOpen={showForm} onClose={() => setShowForm(false)} />
                <WorkerCalleDisplay />
            </div>
        </div>
    )
}
